class TrSelect extends HTMLElement {
	selectors = {
		native: '[data-tr-js-select-native]',
		button: '[data-tr-js-select-button]',
		value: '[data-tr-js-select-value]',
		list: '[data-tr-js-select-list]',
		option: '[data-tr-js-select-option]',
	};

	stateClasses = {
		isOpen: 'is-open',
		isSelected: 'is-selected',
	};

	connectedCallback() {
		this.nativeElement = this.querySelector(this.selectors.native);
		this.buttonElement = this.querySelector(this.selectors.button);
		this.valueElement = this.querySelector(this.selectors.value);
		this.listElement = this.querySelector(this.selectors.list);
		this.optionElements = this.querySelectorAll(this.selectors.option);

		this.init();
		this.bindEvents();
	}

	disconnectedCallback() {
		this.destroy();
	}

	init() {
		this.updateValue();
	}

	bindEvents() {
		this.buttonElement.addEventListener('click', this.onButtonClick);
		this.optionElements.forEach((optionElement) => {
			optionElement.addEventListener('click', this.onOptionClick);
		});
		document.addEventListener('click', this.onDocumentClick);
		document.addEventListener('keydown', this.onDocumentKeydown);
	}

	onButtonClick = () => {
		this.toggle();
	};

	onOptionClick = (event) => {
		const optionElement = event.currentTarget;
		const value = optionElement.dataset.value;

		this.nativeElement.value = value;
		this.nativeElement.dispatchEvent(new Event('change', { bubbles: true }));
		this.updateValue();
		this.close();
	};

	onDocumentClick = (event) => {
		if (this.contains(event.target)) return;

		this.close();
	};

	onDocumentKeydown = (event) => {
		if (event.key !== 'Escape') return;

		this.close();
	};

	toggle() {
		if (this.classList.contains(this.stateClasses.isOpen)) {
			this.close();
			return;
		}

		this.open();
	}

	open() {
		this.classList.add(this.stateClasses.isOpen);
		this.buttonElement.setAttribute('aria-expanded', 'true');
	}

	close() {
		this.classList.remove(this.stateClasses.isOpen);
		this.buttonElement.setAttribute('aria-expanded', 'false');
	}

	updateValue() {
		const selectedOptionElement = this.nativeElement.selectedOptions[0];
		const hasValue = this.nativeElement.value !== '';

		this.valueElement.textContent = selectedOptionElement.textContent.trim();
		this.classList.toggle(this.stateClasses.isSelected, hasValue);

		this.optionElements.forEach((optionElement) => {
			const isSelected = optionElement.dataset.value === this.nativeElement.value;
			optionElement.setAttribute('aria-selected', String(isSelected));
		});
	}

	destroy() {
		this.buttonElement.removeEventListener('click', this.onButtonClick);
		this.optionElements.forEach((optionElement) => {
			optionElement.removeEventListener('click', this.onOptionClick);
		});
		document.removeEventListener('click', this.onDocumentClick);
		document.removeEventListener('keydown', this.onDocumentKeydown);
	}
}

if (!customElements.get('tr-select')) {
	customElements.define('tr-select', TrSelect);
}
